module.exports = __webpack_public_path__ + "img/wlp_question_creation.99bdaad1.png";